var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27108 18.9351H18.9377V16.2684H8.27108V18.9351ZM8.27108 14.9351H24.2711V12.2684H8.27108V14.9351ZM8.27108 10.9351H24.2711V8.2684H8.27108V10.9351ZM2.66675 29.8727V5.6974C2.66675 4.85784 2.96241 4.1424 3.55375 3.55106C4.14508 2.95973 4.86053 2.66406 5.70008 2.66406H26.8421C27.6816 2.66406 28.3971 2.95973 28.9884 3.55106C29.5798 4.1424 29.8754 4.85784 29.8754 5.6974V21.5061C29.8754 22.3456 29.5798 23.0611 28.9884 23.6524C28.3971 24.2437 27.6816 24.5394 26.8421 24.5394H8.00008L2.66675 29.8727ZM6.86675 21.5061H26.8421V5.6974H5.70008V22.6474L6.86675 21.5061Z",
    fill: "url(#paint0_linear_5588_131348)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5588_131348",
    x1: 2.66675,
    y1: 2.66406,
    x2: 29.8754,
    y2: 29.8727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224762,
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852864,
    stopColor: "#1D5AE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcon);
export default __webpack_public_path__ + "static/media/TitleIcon.3d89471b917d6b20c760d84bf4ca8df3.svg";
export { ForwardRef as ReactComponent };